module.exports = __webpack_public_path__ + "static/media/xfactor.7b586e15.mp3";